import { Divider as MuiDivider, styled } from "@mui/material";
import { sectionName } from "../classes.js";
const Divider = styled(MuiDivider, {
  name: sectionName,
  slot: "Divider",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (_props, styles) => [styles.divider]
})(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
